/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useRecoilValue, useSetRecoilState, useRecoilState } from 'recoil';
import { List, ListItem, ListItemAvatar, ListItemText, Avatar, Divider, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import MobileNavbar from './MobileNavbar';
import '../../css/App.scss';
import { projectsDataAtom, openProjectNameAtom, logoToSetAtom } from '../Atoms';
import DetailsPageMobile from './DetailsPageMobile';

const useStyles = makeStyles({
  projectsList: {
    backgroundColor: '#ffffff',
  },
  status: {
    margin: 'unset',
    color: '#00000099',
    fontSize: '16px',
  },
});
const HomePageMobile = function HomePageMobile({ setUser }) {
  const projectsData = useRecoilValue(projectsDataAtom);
  const [openProjectName, setOpenProjectName] = useRecoilState(openProjectNameAtom);
  const setLogoToSet = useSetRecoilState(logoToSetAtom);
  const [searchValue, setSearchValue] = useState(null);
  const [projects, setProjects] = useState(projectsData);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const classes = useStyles();
  const intl = useIntl();
  const steps = [
    {
      label: 'RV1',
      description: `${intl.messages.RV1}`,
    },
    {
      label: 'RV2',
      description: `${intl.messages.RV2}`,
    },
    {
      label: 'RV3',
      description: `${intl.messages.RV3}`,
    },
    {
      label: 'RV4',
      description: `${intl.messages.RV4}`,
    },
    {
      label: 'RV5',
      description: `${intl.messages.RV5}`,
    },
    {
      label: 'RV6',
      description: `${intl.messages.RV6}`,
    },
    {
      label: 'RV7',
      description: `${intl.messages.RV7}`,
    },
  ];
  const getCurrentStep = (value) => {
    let index = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < steps.length; i++) {
      if (steps[i].label.substring(0, 3) === value) {
        index = i + 1;
      }
    }
    if (index === 0) return 0;
    return index;
  };

  const applySearchValue = (word) => {
    const contactsFiltered = projectsData?.filter((x) => x.Name.toLowerCase().includes(word.toLowerCase()));
    return contactsFiltered;
  };
  useEffect(() => {
    if (filtersApplied && searchValue) setProjects(applySearchValue(searchValue));
    else setProjects(projectsData);
  }, [filtersApplied, projectsData]);

  return (
    <div className="mobileHome">
      <MobileNavbar
        setUser={setUser}
        setFiltersApplied={setFiltersApplied}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        filtersApplied={filtersApplied}
      />
      <List className={classes.projectsList}>
        {projects
          .filter((pj) => pj.isCurrent === 1)
          // eslint-disable-next-line func-names
          .sort(function (a, b) {
            const textA = a.Name.toLowerCase();
            const textB = b.Name.toLowerCase();
            // eslint-disable-next-line no-nested-ternary
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })
          .map((pj) => (
            <div
              key={pj.Name}
              onClick={() => {
                setLogoToSet(pj.LOGO);
                setOpenProjectName(pj.Name);
              }}
            >
              <ListItem
                alignItems="flex-start"
                secondaryAction={
                  <Typography className={classes.status}>
                    {intl.messages.STATUS}:{getCurrentStep(pj.finishedPhase) + 1}
                  </Typography>
                }
              >
                <ListItemAvatar>
                  <Avatar alt="Project" src={`data:${pj.LOGO?.contentType};base64,${pj.LOGO?.base64}`} />
                </ListItemAvatar>
                <ListItemText primary={pj.Name} secondary={`${pj.Client} ${pj.RagSociale}`} />
              </ListItem>
              <Divider variant="inset" />
            </div>
          ))}
      </List>
      {openProjectName && <DetailsPageMobile />}
    </div>
  );
};

export default HomePageMobile;
